import React from 'react';
import ReconciliationWizard from './reconciliation/ReconciliationWizard';

const ReconciliationModal = ({
    journalEntryType = 'payment',
    onClose,
    onSubmit,
    makeCallToLinkInvoice = true,
    transactionId,
    recipientId,
    amountToMatch,
    ctaText,
    singleInvoiceOnly = false,
}) => {
    return (
        <ReconciliationWizard
            journalEntryType={journalEntryType}
            onClose={onClose}
            onSubmit={onSubmit}
            makeCallToLinkInvoice={makeCallToLinkInvoice}
            transactionId={transactionId}
            recipientId={recipientId}
            amountToMatch={amountToMatch}
            ctaText={ctaText}
            singleInvoiceOnly={singleInvoiceOnly}
        />
    );
};

export default ReconciliationModal;
